import React from 'react';
import jsPDF from 'jspdf';

const TransactionReport = () => {
  const exportToPDF = () => {
    const doc = new jsPDF();
    
    // Add content to the PDF
    doc.text('Transactions Report', 10, 10);
    
    // Save the PDF
    doc.save('TransactionReport.pdf');
  };

  return (
    <div style={styles.container}>
      <h1>Transactions Report</h1>
      <button style={styles.button} onClick={exportToPDF}>
        Export to PDF
      </button>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px',
  },
  button: {
    backgroundColor: '#4CAF50',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: '16px',
    margin: '4px 2px',
    cursor: 'pointer',
    borderRadius: '5px',
  }
};

export default TransactionReport;
